import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ff884bd"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default,IconsCheckmark: require('/opt/build/repo/components/Icons/Checkmark.vue').default,ElementsRichText: require('/opt/build/repo/components/Elements/RichText.vue').default})
